import OrderInspector from '@/features/orders/components/OrderInspector';
import { useT } from '@/i18n';
import { Navbar, Page } from 'framework7-react';
import type { Router } from 'framework7/types';

/**
 * Phone-only push-navigation page for a single order. On wide layouts the
 * inspector is docked into the workspace's right pane and this route is
 * unreachable from the UI; we keep it for deep links (`/orders/:id`) and for
 * iOS-native push transitions out of the list.
 *
 * All the detail UI lives in `<OrderInspector>` so the docked pane and the
 * pushed page render the exact same content (mirrors `ReservationDetailPage`).
 */
export default function OrderDetailPage({
  f7route,
  f7router,
}: {
  f7route: { params: { id: string } };
  f7router: Router.Router;
}) {
  const t = useT();
  return (
    <Page name="order-detail">
      <Navbar title={t.orders.detail.title} backLink={t.back} />
      {/* Actioning the proof here (mobile / push deep-link) returns to the
          Orders list — the deep-link lands this page on the orders tab whose
          root is the list, so back() resolves to it. */}
      <OrderInspector
        surface="page"
        orderId={f7route.params.id}
        onProofActioned={() => f7router.back()}
      />
    </Page>
  );
}
